import { useDispatch, useSelector } from "react-redux";
import { activeAutomaticAlertSystem } from "../../../redux/alert-system/actions";

function useChangeAlertSystemSettings() {
  const {
    alertSystem: { alertStatus, activeAlertLoading },
    main: { userData },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const {
    risk_taking_amount: riskAppetite,
    alert_frequency: alertFrequency,
    start_time_interval_active: startTime,
    prefered_alert_time: notificationTime,
    end_time_interval_active: endTime,
  } = alertStatus;

  const alertData = {
    riskAppetite,
    alertFrequency,
    balanceThresh: "-1",
    startTime,
    endTime,
    notificationTime,
    assetInDanger: "Yes",
  };

  // newValues is object, and the key of object can be startTime, endTime, notificationTime, and riskAppetite, alertFrequency

  const changeSetting = async (newValues) => {
    const newSetting = { ...alertData, ...newValues };
    await dispatch(
      activeAutomaticAlertSystem(
        userData?.["cognito:username"],
        userData?.["custom:custom_username"],
        newSetting.notificationTime,
        newSetting.alertFrequency,
        newSetting.assetInDanger,
        newSetting.riskAppetite,
        newSetting.startTime,
        newSetting.endTime,
        newSetting.balanceThresh,
      ),
    );
  };

  return changeSetting;
}

export default useChangeAlertSystemSettings;
